import { CreateSaleResponse, SalesRound, Sale } from '@/types/api/sale';
import { Participation } from '@/types/api/sale/participation';
import { CreateSaleRequest } from '@/types/api/sale/request';
import { authenticatedClient } from '@/utils/shared/axios';
import { handleApiError } from '@/utils/shared/handle-api-error';

export default {
  get: async (saleId: string) => {
    const response = await authenticatedClient.get<Sale>(`/sales/${saleId}?include[]=products`);
    return response.data;
  },

  listByGroup: async () => {
    const response = await authenticatedClient.get<Sale[]>(`/sales/group`);
    return response.data;
  },

  create: async (data: CreateSaleRequest): Promise<CreateSaleResponse> => {
    try {
      const response = await authenticatedClient.post<CreateSaleResponse>(`/sales`, data);
      return response.data;
    } catch (error: any) {
      throw handleApiError(error);
    }
  },

  participation: {
    listBySale: async (saleId: string) => {
      const response = await authenticatedClient.get<Participation[]>(`/sales/participations?saleId=${saleId}`);
      return response.data;
    },

    getCurrentBySale: async (saleId: string) => {
      try {
        const response = await authenticatedClient.get<Participation>(
          `/sales/participations/context:${saleId}?include[]=products`,
        );
        return response.data;
      } catch (error: any) {
        throw handleApiError(error);
      }
    },

    getByUserAndSale: async (userId: string, saleId: string) => {
      try {
        const response = await authenticatedClient.get<Participation>(`/sales/participations/${userId}:${saleId}`);
        return response.data;
      } catch (error: any) {
        throw handleApiError(error);
      }
    },
  },

  rounds: {
    list: async () => {
      const response = await authenticatedClient.get<SalesRound[]>(`/sales-rounds`);
      return response.data;
    },

    listAvailable: async () => {
      const response = await authenticatedClient.get<SalesRound[]>(`/sales-rounds/available`);
      return response.data;
    },
  },
};
